"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_query_class_1 = require("../common/base-query.class");
var BaseElementQuery = /** @class */ (function (_super) {
    __extends(BaseElementQuery, _super);
    function BaseElementQuery(config, queryService) {
        var _this = _super.call(this, config, queryService) || this;
        _this.config = config;
        _this.queryService = queryService;
        _this._queryConfig = {};
        return _this;
    }
    /**
     * Use to configure query
     * @param queryConfig Query configuration
     */
    BaseElementQuery.prototype.queryConfig = function (queryConfig) {
        this._queryConfig = queryConfig;
        return this;
    };
    /**
     * Gets headers used by this query
     */
    BaseElementQuery.prototype.getHeaders = function () {
        return this.queryService.getHeaders(this._queryConfig);
    };
    BaseElementQuery.prototype.getElementQueryUrl = function (typeCodename, elementCodename) {
        var action = '/types/' + typeCodename + '/elements/' + elementCodename;
        return _super.prototype.resolveUrlInternal.call(this, action);
    };
    BaseElementQuery.prototype.runElementQuery = function (typeCodename, elementCodename) {
        return this.queryService.getElement(this.getElementQueryUrl(typeCodename, elementCodename), this._queryConfig);
    };
    return BaseElementQuery;
}(base_query_class_1.BaseQuery));
exports.BaseElementQuery = BaseElementQuery;
//# sourceMappingURL=base-element-query.class.js.map